const commentsData = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20minimalist%20portrait%20avatar%20with%20warm%20lighting%2C%20editorial%20style%2C%20soft%20features%2C%20neutral%20expression%2C%20clean%20background&width=120&height=120&seq=avatar-c1&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这个瓜我吃了三天了，越吃越上头！每天蹲更新比追剧还积极，感谢博主整理得这么清楚，不然真的跟不上节奏。',
    likes: 1283,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20editorial%20portrait%20avatar%2C%20warm%20ambient%20light%2C%20soft%20features%2C%20clean%20modern%20composition%2C%20artistic%20style&width=120&height=120&seq=avatar-c2&orientation=squarish',
    name: '八卦研究所',
    time: '5小时前',
    content: '在这蹲了半年了，不得不说信息更新速度是真的快。好几次热搜还没上，这边已经出详细时间线了，服气。',
    likes: 956,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Editorial%20portrait%20avatar%20with%20dramatic%20warm%20lighting%2C%20minimalist%20style%2C%20clean%20background%2C%20artistic%20photography%20vibe&width=120&height=120&seq=avatar-c3&orientation=squarish',
    name: '理性吃瓜人',
    time: '8小时前',
    content: '作为老粉说句公道话，这个平台虽然内容劲爆但至少有来源标注，比那些纯造谣的好太多了。希望能一直保持这个底线。',
    likes: 721,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20editorial%20portrait%20avatar%2C%20warm%20natural%20light%2C%20minimalist%20composition%2C%20clean%20neutral%20background%2C%20artistic%20style&width=120&height=120&seq=avatar-c4&orientation=squarish',
    name: '深夜瓜田守望者',
    time: '12小时前',
    content: '每天晚上睡前必刷一遍，不然总觉得错过了什么大事。上个月那个大瓜就是在这先看到的，朋友圈转了一圈都来问我要链接。',
    likes: 543,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            瓜友热评
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            千万吃瓜群众的真实声音，看看大家都在讨论什么
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {commentsData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {item.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}